/**
 * Staggered Info block script.
 *
 * 3-up icon + heading + description grid. Cards fade up in document order
 * (left to right at desktop, top to bottom at mobile) when the section
 * scrolls into view.
 */

import { revealStagger, motionTokens } from '@/motion-primitives';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-staggered-info').forEach((section) => {
		const grid = section.querySelector('.flex.flex-col, .md\\:grid');
		if (!grid) return;

		revealStagger(grid, {
			childSelector: ':scope > .rmh-staggered-info__item',
			stagger: motionTokens.stagger,
			duration: motionTokens.durMd,
		});
	});
});
